import { render } from "./experience.vue?vue&type=template&id=0f68208a&scoped=true"
import script from "./experience.vue?vue&type=script&lang=js"
export * from "./experience.vue?vue&type=script&lang=js"

import "./experience.vue?vue&type=style&index=0&id=0f68208a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0f68208a"

export default script